import React, { JSX } from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';

interface ISearchResultUserTableCard {
  data: ITableDataSource;
  handleView: (args: string) => void;
  renderHighlight: (arg: string) => '-' | JSX.Element;
}

const SearchResultUserTableCard = ({
  data,
  handleView,
  renderHighlight,
}: ISearchResultUserTableCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: colors.gray200,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('users.usersTable.displayUniqueId.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.displayUniqueId)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('users.usersTable.email.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.email)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('users.usersTable.firstName.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.firstName)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('users.usersTable.lastName.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.lastName)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('users.usersTable.phoneNumber.column')}
        </Typography>
        <Typography variant="body2">{renderHighlight(data.phoneNumber)}</Typography>
      </Grid>

      {handleView && (
        <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: {
              xs: `1px solid ${colors.primary100}`,
              lg: 'none',
            }, p: 2 }}>
          <>
            <Grid size={{ xs: 12, sm: 3 }} sx={{ mb: { xs: 2, sm: 0 } }}>
              <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
                {t('general.actions.text')}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Button
                label={t('general.details.text')}
                variant={EButtonVariants.outlined}
                onClick={() => handleView(data.id as string)}
                size="small"
                fullWidth
              />
            </Grid>
          </>
        </Grid>
      )}
    </Grid>
  );
};

export default SearchResultUserTableCard;
